function getStepperState(state) {
  return {
    lastStep: state.stepper.lastStep,
    lastModule: state.stepper.lastModule
  };
}

export { getStepperState };
